import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'kodit-notifikacije-page',
  templateUrl: './notifikacije-page.component.html',
  styleUrls: ['./notifikacije-page.component.scss'],
})
export class NotifikacijePageComponent implements OnInit {
  //** Props */
  tableOptions!: SelectItem[];
  samoNeprocitane: boolean = true;
  tableSelectOption: boolean = true;

  constructor() {}

  ngOnInit(): void {
    this.tableOptions = [
      { value: true, label: 'Nepročitane' },
      { value: false, label: 'Sve' },
    ];
  }

  handleOnItemChange(e: any) {
    this.samoNeprocitane = e.value;
  }
}
